import React from 'react'
import { useState } from 'react'
import './ImageEnlarge.css' 

const ImageEnlarge = ({src, alt}) => {
    const [enlarged, setEnlarged] = useState(false);

    const toggleEnlarged = () => {
      setEnlarged(!enlarged);
    };
  
  return (
  
    <div className={ `flex__center enlargeable-image ${enlarged ? 'enlarged' : ''}`} onClick={toggleEnlarged}>
      <img src={src} alt={alt} />
    </div>
  )
}

export default ImageEnlarge